module.exports = __webpack_public_path__ + "1dc7193b9a26529890826a8e58518f6b.png";